/**
 * Force Variant Fix - Directly intercepts and corrects variant IDs at the network level
 * This script takes the most direct approach to ensure the correct variant is added
 */

(function() {
  'use strict';
  
  console.log('Force Variant Fix: Starting');
  
  let correctVariantId = null;
  let isProductFormSubmission = false;
  
  // Track variant selection from multiple sources
  document.addEventListener('change', function(event) {
    if (event.target.closest('variant-picker')) {
      const selectedOption = event.target;
      if (selectedOption.dataset.variantId) {
        correctVariantId = selectedOption.dataset.variantId;
        console.log('Force Variant Fix: Stored correct variant ID from change event:', correctVariantId);
      }
    }
  });
  
  // Also listen for the custom VariantUpdateEvent
  document.addEventListener('variant:update', function(event) {
    if (event.detail && event.detail.resource && event.detail.resource.id) {
      correctVariantId = event.detail.resource.id;
      console.log('Force Variant Fix: Stored correct variant ID from VariantUpdateEvent:', correctVariantId);
    }
  });
  
  // Listen for VariantSelectedEvent as well
  document.addEventListener('variant:selected', function(event) {
    if (event.detail && event.detail.resource && event.detail.resource.id) {
      correctVariantId = event.detail.resource.id;
      console.log('Force Variant Fix: Stored correct variant ID from VariantSelectedEvent:', correctVariantId);
    }
  });
  
  // Track form submissions
  document.addEventListener('submit', function(event) {
    const form = event.target;
    if (form && form.action && form.action.includes('/cart/add')) {
      isProductFormSubmission = true;
      console.log('Force Variant Fix: Product form submission detected');
      
      // Set a flag that expires after 5 seconds
      setTimeout(() => {
        isProductFormSubmission = false;
      }, 5000);
    }
  });
  
  // Helper function to get the current variant ID from the active form
  function getCurrentVariantIdFromForm() {
    const activeForm = document.querySelector('form[action*="/cart/add"]');
    if (activeForm) {
      const variantPicker = activeForm.closest('product-form-component')?.querySelector('variant-picker');
      if (variantPicker) {
        const selectedOption = variantPicker.querySelector('input:checked, select option:checked');
        if (selectedOption?.dataset.variantId) {
          return selectedOption.dataset.variantId;
        }
      }
    }
    return null;
  }

  // Override fetch completely
  const originalFetch = window.fetch;
  window.fetch = function(url, options) {
    if (url && url.includes('/cart/add')) {
      console.log('Force Variant Fix: Intercepting fetch to /cart/add');
      
      // Get the most current variant ID from the form
      const currentFormVariantId = getCurrentVariantIdFromForm();
      if (currentFormVariantId) {
        correctVariantId = currentFormVariantId;
        console.log('Force Variant Fix: Updated variant ID from form:', correctVariantId);
      }
      
      if (options && options.body instanceof FormData) {
        const formData = options.body;
        const currentVariantId = formData.get('id');
        
        console.log('Force Variant Fix: Current variant ID in request:', currentVariantId);
        console.log('Force Variant Fix: Correct variant ID:', correctVariantId);
        
        if (correctVariantId && currentVariantId !== correctVariantId) {
          console.log('Force Variant Fix: forcing variant ID from', currentVariantId, 'to', correctVariantId);
          formData.set('id', correctVariantId);
          
          // Also update any other variant-related fields
          formData.set('variant_id', correctVariantId);
          formData.set('variantId', correctVariantId);
        }
      }
    }
    
    return originalFetch.call(this, url, options);
  };
  
  // Override XMLHttpRequest completely
  const originalXHROpen = XMLHttpRequest.prototype.open;
  const originalXHRSend = XMLHttpRequest.prototype.send;
  
  XMLHttpRequest.prototype.open = function(method, url, ...args) {
    this._url = url;
    return originalXHROpen.call(this, method, url, ...args);
  };
  
  XMLHttpRequest.prototype.send = function(data) {
    if (this._url && this._url.includes('/cart/add')) {
      console.log('Force Variant Fix: Intercepting XHR to /cart/add');
      
      // Get the most current variant ID from the form
      const currentFormVariantId = getCurrentVariantIdFromForm();
      if (currentFormVariantId) {
        correctVariantId = currentFormVariantId;
        console.log('Force Variant Fix: XHR updated variant ID from form:', correctVariantId);
      }
      
      if (data instanceof FormData) {
        const currentVariantId = data.get('id');
        
        console.log('Force Variant Fix: XHR current variant ID:', currentVariantId);
        console.log('Force Variant Fix: XHR correct variant ID:', correctVariantId);
        
        if (correctVariantId && currentVariantId !== correctVariantId) {
          console.log('Force Variant Fix: XHR forcing variant ID from', currentVariantId, 'to', correctVariantId);
          data.set('id', correctVariantId);
          data.set('variant_id', correctVariantId);
          data.set('variantId', correctVariantId);
        }
      }
    }
    
    return originalXHRSend.call(this, data);
  };
  
  // Override FormData.set to catch any variant ID changes
  const originalFormDataSet = FormData.prototype.set;
  FormData.prototype.set = function(name, value) {
    if (name === 'id' && correctVariantId && value !== correctVariantId) {
      console.log('Force Variant Fix: FormData.set intercepted - forcing variant ID from', value, 'to', correctVariantId);
      value = correctVariantId;
    }
    return originalFormDataSet.call(this, name, value);
  };
  
  // Override the cart update source detection
  const originalDispatchEvent = EventTarget.prototype.dispatchEvent;
  EventTarget.prototype.dispatchEvent = function(event) {
    if (event.type === 'cart:update' && event.detail && event.detail.data) {
      if (isProductFormSubmission) {
        console.log('🔧 Force Variant Fix: Overriding cart update source to product-form');
        event.detail.data.source = 'product-form';
        event.detail.data.comingFromProductForm = true;
      }
    }
    return originalDispatchEvent.call(this, event);
  };
  
  // Also override the global cart update function
  if (window.dispatchEvent) {
    const originalGlobalDispatchEvent = window.dispatchEvent;
    window.dispatchEvent = function(event) {
      if (event.type === 'cart:update' && event.detail && event.detail.data) {
        if (isProductFormSubmission) {
        console.log('Force Variant Fix: Overriding global cart update source to product-form');
          console.log('Force Variant Fix: Overriding global cart update source to product-form');
          event.detail.data.source = 'product-form';
          event.detail.data.comingFromProductForm = true;
        }
      }
      return originalGlobalDispatchEvent.call(this, event);
    };
  }
  
  console.log('Force Variant Fix: Initialized');
  
})();
